import { promoteSidebarStation, refreshSidebarAroundStation } from './sidebar-controller';
import { drawRouteToStation } from './helpers';

export const handleStationSelect = async ({
    station,
    stations,
    setOpenMarker,
    setExpandedSidebarStationId,
    refreshSidebarStations,
    loadSidebarStationDetails,
    sidebarBatchId,
    setSelectedSidebarStation,
    searchPinLocation,
    userLocation,
    requestUserLocation,
    maps,
    map,
    directionsService,
    directionsRenderer,
}: {
    station: any;
    stations: any[];
    setOpenMarker: (stationId: string | number | null) => void;
    setExpandedSidebarStationId: (stationId: string | number | null) => void;
    refreshSidebarStations: (nextStations: any[], mode: 'nearest' | 'cluster-order' | 'station-proximity', referencePoint: { lat: number; lng: number }, options?: { preserveActiveStation?: boolean }) => void;
    loadSidebarStationDetails: (stationId: string | number, batchId?: number, summaryStation?: any) => Promise<any>;
    sidebarBatchId: number;
    setSelectedSidebarStation: (station: any | null) => void;
    searchPinLocation: { lat: number; lng: number } | null;
    userLocation: { lat: number; lng: number } | null;
    requestUserLocation: () => Promise<{ lat: number; lng: number } | null>;
    maps: typeof google.maps | undefined;
    map: google.maps.Map | undefined;
    directionsService: google.maps.DirectionsService | null;
    directionsRenderer: google.maps.DirectionsRenderer | null;
}) => {
    const stationId = station.properties?.id ?? null;
    setOpenMarker(stationId);
    setExpandedSidebarStationId(stationId);

    refreshSidebarAroundStation({
        station,
        stations,
        refreshSidebarStations,
    });

    if (stationId) {
        const detailedStation = await loadSidebarStationDetails(stationId, sidebarBatchId, station);
        if (detailedStation) {
            promoteSidebarStation({
                station: detailedStation,
                setSelectedSidebarStation,
            });
        } else {
            setSelectedSidebarStation(null);
        }
    }

    const [lng, lat] = station.geometry?.coordinates ?? [];
    if (typeof lat !== 'number' || typeof lng !== 'number') {
        return {
            directionsService,
            directionsRenderer,
        };
    }

    let origin = searchPinLocation ?? userLocation;
    if (!origin) {
        origin = await requestUserLocation();
    }
    if (!origin) {
        return {
            directionsService,
            directionsRenderer,
        };
    }

    return drawRouteToStation({
        destination: {lat, lng},
        origin,
        maps,
        map,
        directionsService,
        directionsRenderer,
    });
};
